import type { RouteKey } from '@/i18n/routes'
export { technologyKeys } from '@/data/technologies'
// Enable a route only after its real page is mounted and verified.
export const readyRoutes: ReadonlySet<RouteKey> = new Set(['home', 'technologies', 'professionalProducts', 'supplements', 'training', 'contacts', 'palermo', 'catania', 'privacy', 'terms', 'm-hydro-5d', 'm-laser-pro', 'm-body-l', 'm-body-s', 'm-press', 'm-shock', 'm-rf-synergy', 'm-synergy-a'])
export const originalSite = 'https://www.medika-italia.it'
export const legacyPaths: Record<RouteKey, string> = {
  home: '/', technologies: '/tecnologie-ok/', professionalProducts: '/prodotti-da-cabina/',
  supplements: '/integratori/', training: '/formazione/', contacts: '/contatti/',
  palermo: '/evento-exclusive-day-palermo/', catania: '/evento-exclusive-day-catania/',
  privacy: '/termini-e-condizioni/#privacy', terms: '/termini-e-condizioni/',
  'm-hydro-5d': '/tecnologie-ok/m-hydro-5d/', 'm-laser-pro': '/tecnologie-ok/m-laser-pro/',
  'm-body-l': '/tecnologie-ok/m-body-l/', 'm-synergy-a': '/tecnologie-ok/m-synergy-a/',
  'm-body-s': '/tecnologie-ok/m-body-s/', 'm-press': '/tecnologie-ok/m-press/',
  'm-shock': '/tecnologie-ok/m-shock/', 'm-rf-synergy': '/tecnologie-ok/m-rf-synergy/',
}
export function publicDestination(key: RouteKey): string {
  return readyRoutes.has(key) ? key : originalSite + legacyPaths[key]
}
